import { DateTime } from 'luxon';

/**
 * Converts date and time values from various formats to Luxon's `DateTime`.
 *
 * NOTE: This should NOT be used to parse user input. This is meant to
 *       be used when one is not certain what format a date time is in.
 */
export function toDateTime(date, setTimezone = true) {
  if (typeof date === 'string') {
    return DateTime.fromISO(date, {
      setZone: !setTimezone
    });
  }
  if (date instanceof Date) {
    return DateTime.fromISO(date.toISOString(), {
      setZone: !setTimezone
    });
  }
  return date;
}